<template>
  <div class="inline-block">
    <div v-if="url" class="sticker-container">
      <img :src="url" :alt="'Sticker'" class="sticker-image" loading="lazy" />
    </div>
    <div
      v-else
      class="flex items-center justify-center w-32 h-32 rounded bg-opacity-10"
      :class="isSent ? 'bg-white' : 'bg-black'"
    >
      <Sticker
        :size="48"
        class="opacity-50"
        :class="
          isSent
            ? 'text-[var(--p-primary-900)] dark:text-[var(--p-primary-100)]'
            : 'text-[var(--p-surface-900)] dark:text-[var(--p-surface-0)]'
        "
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Sticker } from 'lucide-vue-next'

interface Props {
  url?: string
  contentType?: string
  isSent: boolean
}

defineProps<Props>()
</script>

<style scoped>
.sticker-container {
  display: inline-block;
  max-width: 180px;
  max-height: 180px;
}

.sticker-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
</style>
